import React, { Children } from "react";
import { Row } from "../../";
import { useClasses } from "../../";
import classNames from "classnames";
export const styles = (theme) => ({
    formControl: {
        position: "relative",
    },
    label: {
        position: "absolute",
        fontSize: "0.8rem",
        color: "#797979",
        marginTop: "0px",
        zIndex: 0,
        transition: "margin-top 150ms linear, margin-left 150ms linear, font-size 150ms linear, color 150ms linear",
    },
    inputHolder: {
        padding: "18px 0px 0px 0px",
    },
    radioLabel: {
        display: "block",
        position: "relative",
        cursor: "pointer",
        userSelect: "none",
        padding: "5px 8px 8px 26px",
        boxSizing: "border-box",
    },
    radioPosition: {
        position: "absolute",
        margin: "5px 0px 0px 0px",
        top: 0,
        left: 0,
        height: "20px",
        width: "20px",
    },
    radio: {
        opacity: 0,
        cursor: "pointer",
        "& span": {
            display: "block",
            margin: "3px",
            width: "0px",
            height: "0px",
            borderRadius: "10px",
            borderColor: theme.palette.get("formBackground"),
        },
    },
    radioIcon: {
        borderRadius: "25px",
        border: `3px solid ${theme.palette.get("formBackground")}`,
        boxSizing: "border-box",
    },
    radioIconSelected: {
        borderColor: theme.palette.get("primary"),
        transition: "border-color 150ms linear",
        "& span": {
            display: "block",
            margin: "2px",
            width: "10px",
            height: "10px",
            borderRadius: "10px",
            backgroundColor: theme.palette.get("primary"),
            transition: "width 150ms linear, height 150ms linear, background-color 150ms linear,",
        },
    },
    helpBlock: {
        fontSize: "0.8rem",
        lineHeight: "0.8rem",
        color: "rgba(0, 0, 0, 0.75)",
    },
    hasError: {
        color: "rgba(156, 0, 0, 1)",
    },
});
let index = 0;
const Radio = (props) => {
    const { label, inline, value, onChange, children, error, info } = props;
    const classes = useClasses(styles);
    const hasInfo = Boolean(info);
    const hasError = Boolean(error);
    return (React.createElement("div", { className: classes.formControl },
        !inline && (React.createElement("label", { className: classNames([classes.label, hasError && classes.hasError]) }, label)),
        React.createElement("div", { className: classNames([!inline && classes.inputHolder]) },
            React.createElement(Row, { ...props }, Children.map(children, (child) => {
                index++;
                return React.cloneElement(child, {
                    ...child.props,
                    key: "radio-" + index,
                    checked: Boolean(value) && child.props.value === value,
                    onClick: onChange,
                    hasError: Boolean(props.error),
                });
            })),
            hasInfo && !hasError && (React.createElement("span", { className: classNames([classes.helpBlock]) }, info)),
            hasError && (React.createElement("span", { className: classNames([classes.helpBlock, classes.hasError]) }, error)))));
};
export default Radio;
